// extracted by mini-css-extract-plugin
module.exports =  {"ProjectMetadata":"ProjectMetadata-module__ProjectMetadata___fFE6F","main":"ProjectMetadata-module__main___fOmhF","selected":"ProjectMetadata-module__selected___VSv4g"};